module.exports = __webpack_public_path__ + "static/wordpress3-b5b5e4abf627818ba8ffbe861bd7170a.png";